import { EditControl } from "../forms/form-row";
import { Txt } from "../common/text";
import { GoogleMapsModal, LocationInfo } from "./google-maps-modal";

export class MapEditControl implements EditControl
{
    private container!: HTMLDivElement;
    private input!: HTMLButtonElement;
    private place: LocationInfo = null;
    private changeActions: (() => void)[] = [];

    initialize(parent: HTMLElement)
    {
        this.container = document.createElement("div");
        this.container.classList.add("map-row-control");
        parent.append(this.container);

        this.input = document.createElement("button");
        this.input.type = "button";
        this.input.textContent = Txt.selectLocation;
        this.input.className = "w-button-primary";
        this.input.onclick = () => this.openModal();
        this.container.append(this.input);
    }

    private openModal()
    {
        const modal = new GoogleMapsModal(this.place, false);

        modal.showModal(
            place =>
            {
                this.place = place;
                this.input.textContent = place?.Address ?? Txt.selectLocation;
                this.changeActions.forEach(fn => fn());
            }
        );
    }

    async setValue(value: string)
    {
        this.place = value ? JSON.parse(value) : null;
        this.input.textContent = this.place?.Address || Txt.selectLocation;
    }

    getValue()
    {
        if (!this.place)
        {
            return null;
        }
        return JSON.stringify(this.place);
    }

    onChange(action: () => void)
    {
        this.changeActions.push(action);
    }

    validate()
    {
        return true;
    }

    focus()
    {
        this.input.scrollIntoView({ behavior: "smooth", block: "center" });
    }
}
